import { NoSettingsPanel } from './NoSettingsPanel.js';

export function DayOfSchoolPageSettings() {
  return (
    <NoSettingsPanel
      pageLabel="Day of school"
      description="The hundreds-chart counter that tracks each day of school. Days are marked directly on the chart during morning meeting (and auto-marked from your school calendar)."
    />
  );
}
